// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"61":"vsf-contact","87":"vsf-privacy-policy","231":"vsf-home","278":"vsf-project","664":"vsf-page-not-found","855":"vsf-contact-success"}[chunkId] + "." + {"61":"7ef3257b","87":"53cf641d","231":"1237dd22","278":"de4b3d12","664":"ef500377","855":"d5d77be3"}[chunkId] + ".js";
};